import type {
	RemoveNodeCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';

import { findNodeByLocalId } from './utils/find-node-by-local-id';

export const createRemoveNodeCommand: StreamingCommandFactory<RemoveNodeCommand> =
	(api) => (command) => {
		api.core.actions.execute(({ tr }) => {
			findNodeByLocalId(tr, command.localId, ({ node, pos }) => {
				tr.delete(pos, pos + node.nodeSize).scrollIntoView();
			});
			return tr;
		});
		return true;
	};
